import { Checkbox } from 'primereact/checkbox';
import { InputText } from 'primereact/inputtext';
import { classNames } from 'primereact/utils';

import '../layout/sass/_form.scss';

export const FormPreparoSolo = ({ values, setFieldValue, setFieldTouched, errors, touched }) => {
    const isFormFieldValid = (name) => {
        const isValid = !!(touched?.[name] && errors?.[name]);
        return isValid;
    };
    const handleCheckboxChange = (e) => {
        const { name, checked } = e.target;
        setFieldValue(`preparoSolo.${name}`, checked);
        setFieldTouched(`preparoSolo.${name}`, true);

        if ((name === 'leve' || name === 'pesada' || name === 'niveladora') && checked) {
            setFieldValue("preparoSolo.gradagemComGrade", true);
        }

        if (name !== 'naoNecessarias' && checked) {
            setFieldValue("preparoSolo.naoNecessarias", false);
        }

        if (name === "gradagemComGrade" && !checked) {
            setFieldValue("preparoSolo.leve", false);
            setFieldValue("preparoSolo.pesada", false);
            setFieldValue("preparoSolo.niveladora", false);
        }

        if (name === 'outras' && !checked) {
            setFieldValue("preparoSolo.descricaoOutras", '');
        }

        if (name === 'naoNecessarias' && checked) {
            setFieldValue("preparoSolo.subsolagem", false);
            setFieldValue("preparoSolo.aracao", false);
            setFieldValue("preparoSolo.enxadaRotativa", false);
            setFieldValue("preparoSolo.gradagemComGrade", false);
            setFieldValue("preparoSolo.leve", false);
            setFieldValue("preparoSolo.pesada", false);
            setFieldValue("preparoSolo.niveladora", false);
            setFieldValue("preparoSolo.outras", false);
            setFieldValue("preparoSolo.descricaoOutras", '');
        }
    };

    const handleTextChange = (e) => {
        const { name, value } = e.target;
        setFieldValue(`preparoSolo.${name}`, value);
        setFieldTouched(`preparoSolo.${name}`, true);
    };

    return (
        <div className="card p-grid p-col-12 p-mx-0 p-mt-0">
            <div className="p-col-12">
                <div className="p-formgrid p-grid p-fluid p-mx-0">
                    <div className="p-field p-col-12">
                        <label><strong>Operações Realizadas:</strong></label>
                        <div className="p-d-flex p-flex-wrap p-ai-center ">
                            <div className="p-field p-d-flex p-ai-center p-mr-3 p-mb-3 p-col">
                                <label htmlFor="naoNecessarias" className={classNames('p-mr-2', { 'p-error': isFormFieldValid('naoNecessarias') })}>
                                    Não são necessárias
                                </label>
                                <Checkbox
                                    id="naoNecessarias"
                                    name="naoNecessarias"
                                    checked={values.naoNecessarias}
                                    onChange={handleCheckboxChange}
                                />
                            </div>
                            <div className="p-field p-d-flex p-ai-center p-mr-3 p-mb-3 p-col">
                                <label htmlFor="subsolagem" className={classNames('p-mr-2', { 'p-error': isFormFieldValid('subsolagem') })}>
                                    Subsolagem
                                </label>
                                <Checkbox
                                    id="subsolagem"
                                    name="subsolagem"
                                    checked={values.subsolagem}
                                    onChange={handleCheckboxChange}
                                />
                            </div>
                            <div className="p-field p-d-flex p-ai-center p-mr-3  p-ml-3 p-mb-3 p-col">
                                <label htmlFor="aracao" className={classNames('p-mr-2', { 'p-error': isFormFieldValid('aracao') })}>
                                    Aração
                                </label>
                                <Checkbox
                                    id="aracao"
                                    name="aracao"
                                    checked={values.aracao}
                                    onChange={handleCheckboxChange}
                                />
                            </div>
                            <div className="p-field p-d-flex p-ai-center p-mr-3 p-mb-3 p-col">
                                <label htmlFor="enxadaRotativa" className={classNames('p-mr-2', { 'p-error': isFormFieldValid('enxadaRotativa') })}>
                                    Enxada Rotativa
                                </label>
                                <Checkbox
                                    id="enxadaRotativa"
                                    name="enxadaRotativa"
                                    checked={values.enxadaRotativa}
                                    onChange={handleCheckboxChange}
                                />
                            </div>
                            <div className="p-field p-d-flex p-ai-center p-mr-5  p-ml-3 p-mb-3 p-col">
                                <label htmlFor="gradagemComGrade" className={classNames('p-mr-2', { 'p-error': isFormFieldValid('gradagemComGrade') })}>
                                    Gradagem com Grade
                                </label>
                                <Checkbox
                                    id="gradagemComGrade"
                                    name="gradagemComGrade"
                                    checked={values.gradagemComGrade}
                                    onChange={handleCheckboxChange}
                                />
                            </div>
                            <div className="p-field p-d-flex p-ai-center p-ml-3 p-mb-3 p-col">
                                <label htmlFor="leve" className={classNames('p-mr-2', { 'p-error': isFormFieldValid('leve') })}>
                                    Leve
                                </label>
                                <Checkbox
                                    id="leve"
                                    name="leve"
                                    checked={values.leve}
                                    onChange={handleCheckboxChange}
                                />
                            </div>
                            <div className="p-field p-d-flex p-ai-center p-mb-3 p-col">
                                <label htmlFor="pesada" className={classNames('p-mr-2', { 'p-error': isFormFieldValid('pesada') })}>
                                    Pesada
                                </label>
                                <Checkbox
                                    id="pesada"
                                    name="pesada"
                                    checked={values.pesada}
                                    onChange={handleCheckboxChange}
                                />
                            </div>
                            <div className="p-field p-d-flex p-ai-center  p-ml-3 p-mb-3 p-col">
                                <label htmlFor="niveladora" className={classNames('p-mr-2', { 'p-error': isFormFieldValid('niveladora') })}>
                                    Niveladora
                                </label>
                                <Checkbox
                                    id="niveladora"
                                    name="niveladora"
                                    checked={values.niveladora}
                                    onChange={handleCheckboxChange}
                                />
                            </div>
                            <div className="p-field p-d-flex p-ai-center p-ml-5 p-mb-3 p-col-4">
                                <label htmlFor="outras" className={classNames('p-mr-2', { 'p-error': isFormFieldValid('outras') })}>
                                    Outras
                                </label>
                                <Checkbox
                                    id="outras"
                                    name="outras"
                                    checked={values.outras}
                                    onChange={handleCheckboxChange}
                                />
                                <div className="p-d-flex p-ai-center p-ml-2 p-mb-3 p-col-11">
                                    <InputText
                                        id="descricaoOutras"
                                        name="descricaoOutras"
                                        value={values.descricaoOutras}
                                        onChange={handleTextChange}
                                        disabled={!values.outras}
                                        placeholder="Descreva aqui..."
                                        className={classNames('p-mt-3', { 'p-invalid': isFormFieldValid('descricaoOutras') })}
                                    />
                                    {isFormFieldValid('descricaoOutras') && (
                                        <small className="p-error p-ml-2">{errors.descricaoOutras}</small>
                                    )}
                                </div>
                            </div>
                        </div>
                        {values.gradagemComGrade && !values.leve && !values.pesada && !values.niveladora && (
                            <div className="p-error">Pelo menos uma opção de gradagem deve ser selecionada.</div>
                        )}
                        {!values.naoNecessarias && !values.subsolagem && !values.aracao && !values.enxadaRotativa && !values.gradagemComGrade && !values.leve && !values.pesada && !values.niveladora && !values.outras && (
                            <div className="p-error">Pelo menos uma opção deve ser selecionada.</div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}